import type { FC } from 'react';

import { Button, EnvelopeIcon, TickCircleIcon } from '@motorway/mw-highway-code';

import { modalService } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';

import styles from './NothingToSend.module.scss';

export const NothingToSend: FC = () => (
	<div className={styles.container}>
		<div className={styles.icons}>
			<EnvelopeIcon data-thc-icon-envelop />
			<TickCircleIcon data-thc-icon-tick />
		</div>
		<div className={styles.message}>
			<span className={styles.title}>{T.translate('nothingToSend.title')}</span>
			<span>{T.translate('nothingToSend.text')}</span>
		</div>
		<Button
			data-thc-button
			label={T.translate('nothingToSend.backButton')}
			onClick={modalService.onClose}
			variant="secondary"
		/>
	</div>
);
